/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
function InfoTooltip(_ref) {
  var _ref$triggerClassName = _ref.triggerClassName,
    triggerClassName = _ref$triggerClassName === void 0 ? '' : _ref$triggerClassName,
    _ref$tooltipId = _ref.tooltipId,
    tooltipId = _ref$tooltipId === void 0 ? 'tooltip' : _ref$tooltipId,
    tooltipText = _ref.tooltipText,
    _ref$tooltipPlacement = _ref.tooltipPlacement,
    tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement;
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: tooltipPlacement,
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: tooltipId
    }, tooltipText)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-info-circle ".concat(triggerClassName)
  }));
}
InfoTooltip.propTypes = {
  triggerClassName: PropTypes.string,
  tooltipId: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  tooltipPlacement: PropTypes.string
};
export default InfoTooltip;